const aos = function (next) {

	const aosElements = next.querySelectorAll('[data-aos]')

	let options = {
		rootMargin: '0px 0px -86px 0px',
		threshold: 0
	}

	const aosObserver = new IntersectionObserver(els => {
		els.forEach(el => {
			const element = el.target

			if (el.isIntersecting) {
				element.classList.add('animate');
				aosObserver.unobserve(element);
				return;
			}

			// element.classList.remove('animate'); // Remove element on scroll up
		});
	}, options);

	aosElements.forEach(el => {
		aosObserver.observe(el);
	})

	// Separate Observer for 'donate' side-fixed CTA:
	const donateCTA = next.querySelector('#donateCTA')
	if (donateCTA !== null) {
		const donateObserver = new IntersectionObserver((els) => {
			els.forEach((el) => {
				if (el.isIntersecting) {
					// console.log('hiding')
					donateCTA.classList.remove('show');
				} else {
					// console.log('showing')
					donateCTA.classList.add('show');
				}
			})
		})

		const headerElements = next.querySelectorAll('.featured-project-hero, .project-hero, .page-hero');

		headerElements.forEach(el => {
			donateObserver.observe(el);
		})
	}

}
export default aos
